export function selectStockDisplayQuote(publishedQuote, sessionQuote) {
  const useSessionQuote = Boolean(
    sessionQuote
    && sessionQuote.trade_date
    && Number(sessionQuote.open) > 0
    && sessionQuote.trade_date >= publishedQuote.trade_date
  );
  return {
    isLiveSession: useSessionQuote,
    quote: useSessionQuote
      ? {
          ...sessionQuote,
          close: sessionQuote.price,
          trade_date: sessionQuote.trade_date,
        }
      : publishedQuote,
  };
}

export function appendLiveDailyBar(bars = [], sessionQuote = null) {
  if (!sessionQuote?.trade_date || Number(sessionQuote.open) <= 0) return bars;
  const liveBar = {
    t: sessionQuote.trade_date,
    open: Number(sessionQuote.open),
    high: Number(sessionQuote.high),
    low: Number(sessionQuote.low),
    close: Number(sessionQuote.price),
    pre_close: Number(sessionQuote.pre_close),
    pct_chg: Number(sessionQuote.pct_chg),
    volume_shares: Number(sessionQuote.volume) * 100,
    amount_cny: Number(sessionQuote.amount_cny),
    ma20: null,
  };
  const last = bars.at(-1);
  if (!last || last.t < liveBar.t) return [...bars, liveBar];
  if (last.t === liveBar.t) {
    return [...bars.slice(0, -1), { ...liveBar, ma20: last.ma20 ?? null }];
  }
  return bars;
}
